import { Box, CircularProgress, Typography } from '@mui/material'
import { green, grey, red, yellow } from '@mui/material/colors'

type StatWithProgressProps = {
  value: number
  size?: number
  thickness?: number
}

function StatWithProgress({
  value,
  size = 35,
  thickness = 8,
}: StatWithProgressProps) {
  const rawPercentage = value * 100
  const percentage =
    rawPercentage < 0.5
      ? Math.round(rawPercentage * 10000) / 10000
      : Math.round(rawPercentage)

  const getColor = () => {
    if (rawPercentage < 50) return red[500]
    if (rawPercentage < 80) return yellow[700]
    return green[500]
  }

  const color = getColor()

  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={100}
          size={size}
          thickness={thickness}
          sx={{ color: grey[300], position: 'absolute' }}
        />
        <CircularProgress
          variant="determinate"
          value={rawPercentage}
          size={size}
          thickness={thickness}
          sx={{ color }}
        />
      </Box>
      <Typography variant="h3" fontWeight="bold">
        {percentage}%
      </Typography>
    </Box>
  )
}

export default StatWithProgress
